export const escapeEventParkingSearchSql = (value: string): string => value.replace(/'/g, "''");

export function buildEventParkingSearchVariants(term: string): string[] {
  const trimmed = term.trim().toUpperCase();
  if (!trimmed) {
    return [];
  }

  const variants = new Set<string>([trimmed]);
  const compact = trimmed.replace(/[\s_-]+/g, '');
  if (compact) {
    variants.add(compact);
  }

  const lotToken = compact.match(/^LOT0*(\d+)$/)?.[1] ?? compact.match(/^0*(\d+)$/)?.[1];
  if (lotToken) {
    const normalized = String(parseInt(lotToken, 10));
    variants.add(normalized);
    variants.add(`LOT ${normalized}`);
    variants.add(`LOT${normalized}`);
    variants.add(`LOT${normalized.padStart(2, '0')}`);
    variants.add(`LOT${normalized.padStart(3, '0')}`);
  }

  return Array.from(variants).filter(Boolean);
}

export function buildLikeAnyWhere(fieldName: string, values: string[]): string {
  return values
    .map((value) => `${fieldName} LIKE '%${escapeEventParkingSearchSql(value)}%'`)
    .join(' OR ');
}

export function buildEventTypeWhere(aliasEventType: string | string[]): string {
  if (Array.isArray(aliasEventType)) {
    const values = aliasEventType.map((value) => `'${escapeEventParkingSearchSql(value)}'`).join(', ');
    return `event_type IN (${values})`;
  }

  return `event_type = '${escapeEventParkingSearchSql(aliasEventType)}'`;
}

